import Logo from './logo-spacefill.svg';

const SpacefillLogo = (props) => {
    return (
        <img
            src={Logo}
            alt='logo'
            {...props}
            className={props.className}
        />
    );
};

export { SpacefillLogo };
